import {
    call,
    select
} from 'redux-saga/effects';

import { error } from '../../../core/js/utils/logger';

import { buildCartEntity } from '../utils/buildCartEntityUtils';
import apiRoutes from '../../../core/js/utils/apiRoutes';
import { makeRequest } from '../../../core/js/sagas/makeRequest';
import productUtils from '../utils/utils';

function createBackInStockCartEntity(state, emailAddress, component) {
    let product;

    if (component.forFamilyProduct) {
        product = state.product.familyProducts[component.multipleIndex];
    } else {
        product = productUtils.getProductForAction(state);
    }

    const entity = {
        controls: {
            quantity: 1
        },
        sku: product.selectedSku.sku,
        backInStockNotification: {
            emailAddress: emailAddress,
            cartType: 'WATCH'
        }
    };

    return buildCartEntity(entity);
}

export function *backInStockNotificationSaga(emailAddress, component) {
    let state = yield select();

    const cartEntity = createBackInStockCartEntity(state, emailAddress, component);
    const addToCartRoute = apiRoutes.addToCartRoute(state, cartEntity);

    try {
        yield call(makeRequest, addToCartRoute);
    } catch (err) {
        error('backInStockNotificationSaga: addToCart error', err);
        throw error;
    }
}
